export default "__VITE_ASSET__Btoq6pQm__"